export default __webpack_public_path__ + "static/media/open-tab-icon.6e07ea98.svg";